import { useState } from "react"

import { Dialog, spacing, Text } from "@minuthq/meatball-ui-react"

import { isProdEnv } from "src/constants/env"
import { storeUrl } from "src/constants/hrefs"
import { usePostPurchaseHomeDialogClicked } from "src/data/analytics/queries/purchaseHomeDialogAnalyticsQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { MLocation } from "src/router/routeTypes"
import { useRouter } from "src/router/useRouter"
import { RadioGroup } from "src/ui/RadioGroup/RadioGroup"

type TPurchaseType = "unit_only" | "unit_device"

export function PurchaseHomeDialog({
  open,
  onClose,
  unitOnlyLocation,
}: {
  open: boolean
  onClose: () => void
  unitOnlyLocation: Partial<MLocation>
}) {
  // #region Analytics
  const postPurchaseHomeDialogClicked = usePostPurchaseHomeDialogClicked()
  // #endregion

  const { t, langKeys } = useTranslate()
  const { navigate } = useRouter()

  const [selectedPurchaseType, setSelectedPurchaseType] =
    useState<TPurchaseType>("unit_device")

  function closeDialog() {
    setSelectedPurchaseType("unit_device")
    onClose()
  }

  function handleConfirm() {
    if (selectedPurchaseType === "unit_only") {
      postPurchaseHomeDialogClicked.mutate({
        selection: "unit_only",
      })
      navigate(unitOnlyLocation)
      return
    }

    postPurchaseHomeDialogClicked.mutate(
      {
        selection: "unit_device",
      },
      {
        onSettled: () => {
          window.open(
            isProdEnv ? storeUrl.production : storeUrl.staging,
            "_self"
          )
        },
      }
    )
  }

  return (
    <Dialog
      open={open}
      title={t(langKeys.no_prepaid_homes_dialog_title)}
      onClose={closeDialog}
      onConfirm={handleConfirm}
      confirmLabel={t(langKeys.continue)}
      closeLabel={t(langKeys.cancel)}
    >
      <RadioGroup
        value={selectedPurchaseType}
        onChange={setSelectedPurchaseType}
        options={[
          {
            value: "unit_device",
            render: () => (
              <div>
                <Text variant="heading3" marginBottom={spacing.XS}>
                  {t(langKeys.no_prepaid_homes_dialog_home_device_title)}
                </Text>
                <Text>
                  {t(langKeys.no_prepaid_homes_dialog_home_device_description)}
                </Text>
              </div>
            ),
          },
          {
            value: "unit_only",
            render: () => (
              <div>
                <Text variant="heading3" marginBottom={spacing.XS}>
                  {t(langKeys.no_prepaid_homes_dialog_device_only_title)}
                </Text>
                <Text>
                  {t(langKeys.no_prepaid_homes_dialog_device_only_description)}
                </Text>
              </div>
            ),
          },
        ]}
        hideRadio
      />
    </Dialog>
  )
}
